import type { FC, SVGProps } from 'react'

export const EducationAutoEpoch: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24 15.8C24 17.3464 21 20 21 20C21 20 18 17.3464 18 15.8C18 14.2536 19.3431 13 21 13C22.6569 13 24 14.2536 24 15.8Z"
      fill="white"
      fillOpacity="0.9"
    />
    <path
      d="M24 15.8C24 17.3464 21 20 21 20C21 20 18 17.3464 18 15.8C18 14.2536 19.3431 13 21 13C22.6569 13 24 14.2536 24 15.8Z"
      fill="url(#paint0_linear_4078_19787)"
    />
    <path
      d="M7 5C8.5 23.5 21 24 26.5 21.5"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M4 5V28H27"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4078_19787"
        x1="18"
        y1="16.5"
        x2="24"
        y2="16.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3FFAB" />
        <stop offset="1" stopColor="#12FFF7" />
      </linearGradient>
    </defs>
  </svg>
)
